import { render, staticRenderFns } from "./DuplicateViews.vue?vue&type=template&id=9de0505c&scoped=true&"
import script from "./DuplicateViews.vue?vue&type=script&lang=js&"
export * from "./DuplicateViews.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateViews.vue?vue&type=style&index=0&id=9de0505c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de0505c",
  null
  
)

export default component.exports